// extracted by mini-css-extract-plugin
export default {"giftBlock":"DrawsTopBlock_giftBlock__G67tC","giftInfoItem":"DrawsTopBlock_giftInfoItem__1tDpE","highlight":"DrawsTopBlock_highlight__N9OVk","shine":"DrawsTopBlock_shine__O+6q6"};